import React from "react";
import { Form, Input, Select, Button, Icon, Alert } from "antd";
import isEqual from "lodash/isEqual";

import {
  valuesAndErrorsToFields,
  validateJsonObject,
  prettyPrintJSONString,
} from "../../shared/util/antdForm";

import UpdateAllSessionsFromScenarioButton from "../UpdateAllSessionsFromScenarioButton";

const ScenarioForm = Form.create()(
  class C extends React.Component {
    static defaultProps = {
      onScenarioEditorRequested: (row) => {},
    };

    state = {
      formErrors: undefined,
    };

    componentDidUpdate(prevProps) {
      if (!isEqual(prevProps.rowUpdate, this.props.rowUpdate)) {
        this.props.form.setFieldsValue(this.props.rowUpdate);
      }
    }

    handleSubmit = (e) => {
      const { form, onSubmit, row } = this.props;

      e.preventDefault();
      form.validateFields(async (err, values) => {
        if (err) {
          return;
        }

        const errors = await onSubmit(row, values);
        if (!errors) {
          return;
        }

        this.setState({ formErrors: errors["_errors"] });
        form.setFields(valuesAndErrorsToFields(values, errors));
      });
    };

    render() {
      const {
        user,
        row,
        licenseSet,
        loading,
        form: { getFieldDecorator },
        onScenarioEditorRequested,
      } = this.props;

      const { formErrors } = this.state;

      return (
        <Form onSubmit={this.handleSubmit} autoComplete="off" layout="vertical">
          {formErrors && (
            <Form.Item>
              {formErrors.map((error, index) => (
                <Alert
                  key={index}
                  message={error.toString()}
                  type="error"
                  showIcon
                />
              ))}
            </Form.Item>
          )}

          <Form.Item label="Name">
            {getFieldDecorator("name", {
              rules: [{ required: true, message: "Name is required" }],
              validateTrigger: ["onBlur"],
              initialValue: row.name,
            })(<Input type="text" placeholder="Please enter a name" />)}
          </Form.Item>

          <Form.Item label="Description">
            {getFieldDecorator("description", {
              validateTrigger: ["onBlur"],
              initialValue: row.description,
            })(
              <Input.TextArea
                placeholder="Please enter a description"
                autoSize={{ minRows: 1, maxRows: 5 }}
              />
            )}
          </Form.Item>

          <Form.Item label="Definition">
            {getFieldDecorator("definition", {
              rules: [
                {
                  required: true,
                  message: "A definition (even if empty) is required",
                },
                {
                  validator: validateJsonObject,
                  message: "A valid json object is required",
                },
              ],
              validateTrigger: ["onBlur"],
              normalize: (value) => prettyPrintJSONString(value),
              initialValue: prettyPrintJSONString(row.definition || "{}"),
            })(
              <Input.TextArea
                placeholder="Please enter a definition as a json object"
                autoSize={{ minRows: 4, maxRows: 10 }}
              />
            )}
            <Button onClick={() => onScenarioEditorRequested(row)}>
              <Icon type="edit" />
            </Button>
          </Form.Item>

          {(() => {
            if (user.isAdmin) {
              return (
                <Form.Item label="License">
                  {getFieldDecorator("licenseId", {
                    validateTrigger: ["onBlur"],
                    initialValue: row.licenseId,
                  })(
                    <Select placeholder="Select a license">
                      <Select.Option value={null}>---</Select.Option>
                      {licenseSet.map(({ id, name }) => (
                        <Select.Option key={id} value={id}>
                          {name}
                        </Select.Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              );
            }
          })()}

          {user.isAdmin && (
            <Form.Item label="Linked licenses">
              {getFieldDecorator("licensesIds", {
                validateTrigger: ["onBlur"],
                initialValue: row.licensesIds || [],
              })(
                <Select
                  mode="multiple"
                  placeholder="Select licenses to link to"
                >
                  {licenseSet.map(({ id, name }) => (
                    <Select.Option key={id} value={id}>
                      {name}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          )}

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Save
            </Button>{" "}
            <UpdateAllSessionsFromScenarioButton
              scenarioId={row.id}
              label="Update sessions"
            />
          </Form.Item>
        </Form>
      );
    }
  }
);

export default ScenarioForm;
